export const toursProgramData = {
  title: "Program zájezdů v sobotu 15.11. 2025",
  agendaItems: [
    {
      subtitle: "Za vyhlídkami do údolí Moravice",
      subtitleClarification:
        "výprava do údolí jedné z našich nejkrásnějších řek",
      descriptions: [
        "Jakubčovice - rozhledna Šance",
        "Hradec nad Moravicí - Červený zámek, Slezská kalvárie, Bezručova vyhlídka",
        "Zřícenina hradu Vikštejn",
      ],
      src: "/images/program/rozhledna-Sance.JPG",
    },
    {
      subtitle: "Za fenomény Hlučínska",
      subtitleClarification: "s odborným výkladem pracovníků Muzea Hlučínska",
      descriptions: [
        "Červená architektura - sakrální i světské stavby",
        "Dvůr Albertovec, Chuchelná - hrobka Lichnovských",
        "Sudice - památník osvobození, kostel sv. Jana Křtitele",
      ],
      src: "/images/program/kostel-z-reznych-cihel.jpg",
    },
    {
      subtitle: "Pohornickou krajinou Karvinska",
      subtitleClarification: "po stopách románu Šikmý kostel ",
      descriptions: [
        "Šikmý kostel - Kostel sv. Petra z Alkantary v Karviné",
        "Karvinské moře",
        "Zámek Fryštát - expozice a zámecký park",
      ],
      src: "/images/program/sikmy-kostel.JPG",
    },
    {
      subtitle: "Kolem Odry do Ratiboře",
      subtitleClarification: "za poznáním česko-polského příhraničí",
      descriptions: [
        "Chalupki - zámecký park, hraniční meandry Odry - procházka",
        "Tworków - zřícenina zámku s parkem, zámecká věž",
        "Prohlídka města Ratiboř (Racibórz)",
      ],
      src: "/images/program/Ratibor.JPG",
    },
  ],
};
